import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';
import { sortArrayByFieldName } from 'utils/helpers/sort-array-by-field-name';

import useApi from '../use-api';

import type { IAdherenceSettingCohortsInactiveDays } from 'infrastructure/interfaces';

const api = `core-2/adherence-settings/adherence-cohorts-inactive-days`;

export const useGetCohortsInactiveDays = () => {
  const { loadData } = useApi();

  const {
    data = [],
    error,
    isLoading,
  } = useQuery<IAdherenceSettingCohortsInactiveDays[]>({
    queryKey: ['useGetCohortsInactiveDays'],
    staleTime: STALE_TIME,
    queryFn: async () => {
      const res = await loadData<IAdherenceSettingCohortsInactiveDays[]>(api);
      if (res)
        return sortArrayByFieldName(
          res.map((el) => ({
            ...el,
            inactiveAdherenceCohorts: el.inactiveAdherenceCohorts ?? [],
          })),
          'from',
        );
      return [];
    },
  });

  return {
    data,
    isLoading,
    error,
  };
};
